import { GoogleMap, useLoadScript, Marker, MarkerF } from "@react-google-maps/api";
import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from "react";
import { GoogleApiWrapper } from "google-maps-react";

import { addMarkers, addMarkersData } from "./helper";

var currentMapRef;
const Map = (props) => {
    const [mapref, setMapRef] = React.useState(null);
    const [map, setMap] = useState(null);
    currentMapRef = useRef(null);

    const refresh = (data) => {
        let lastLocation = localStorage.getItem("lastLocation");
        if (lastLocation && currentMapRef.current) {
            lastLocation = JSON.parse(lastLocation);
            addMarkers(currentMapRef.current, props, [lastLocation], data, currentMapRef);
            addMarkersData(currentMapRef.current, data, props);
        }
    };

    const handleOnLoad = (map) => {
        setMapRef(map);
        props.onRefresh({ onRefresh: refresh });
        currentMapRef.current = map;
        props.onMapRefChange(map);
        let lastLocation = localStorage.getItem("lastLocation");
        if (lastLocation) {
            lastLocation = JSON.parse(lastLocation);
            addMarkers(map, props, [lastLocation], props.locations, currentMapRef);
        }
    };

    const handleReady = (map) => {
        setMap(map);
    };

    const handleSimpleOnLoad = (map) => {
        if (props.onMapChange) {
            props.onMapChange(map);
        }
    };

    return (
        <>
            {!props.simpleMap && (
                <GoogleMap
                    options={{ mapId: process.env.REACT_APP_GOOGLE_MAP_ID, minZoom: 5 }}
                    xs={10}
                    zoom={props.zoom}
                    initialCenter={props.coordinates}
                    center={props.coordinates}
                    onReady={(mapProps, map) => handleReady(map)}
                    libraries={["common", "util", "map", "overlay", "onion", "controls", "stats", "places", "geometry"]}
                    onLoad={handleOnLoad}
                    mapContainerStyle={
                        props.dimensions ? props.dimensions : { width: "100%", height: "calc(100vh - 64px)" }
                    }
                ></GoogleMap>
            )}
            {props.simpleMap && (
                <GoogleMap
                    disableDefaultUI={true}
                    options={{
                        mapId: process.env.REACT_APP_GOOGLE_MAP_ID,
                        zoomControl: false,
                        mapTypeControl: false,
                        scaleControl: false,
                        streetViewControl: false,
                        rotateControl: false,
                        fullscreenControl: false,
                    }}
                    xs={10}
                    zoom={props.zoom}
                    initialCenter={props.coordinates}
                    center={props.coordinates}
                    onLoad={handleSimpleOnLoad}
                    libraries={["places"]}
                    mapContainerStyle={props.dimensions}
                >
                    {props.coordinates && <MarkerF position={props.coordinates}></MarkerF>}
                </GoogleMap>
            )}
        </>
    );
};

const LoadingContainer = (props) => <div></div>;

export default GoogleApiWrapper({
    apiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
    version: "beta",
    libraries: ["common", "util", "map", "overlay", "onion", "controls", "stats", "places", "geometry"],
    LoadingContainer: LoadingContainer,
})(Map);
